import { render } from "./AuctionsEditing.vue?vue&type=template&id=67b28b04&ts=true"
import script from "./AuctionsEditing.vue?vue&type=script&lang=ts"
export * from "./AuctionsEditing.vue?vue&type=script&lang=ts"

import "./AuctionsEditing.vue?vue&type=style&index=0&id=67b28b04&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__